import React from 'react';
import {MeetingTabs} from './components/MeetingTabs';
import {InvitationDataGrid} from './components/InvitationDataGrid';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {
  accountNameColumn,
  clientsColumn,
  completedOnColumn,
  ownerColumn,
  meetingHostColumn,
  locationColumn,
  propositionTypeColumn,
  rtqStatusColumn,
  ecqStatusColumn,
} from './invitationColumns';
import {InvitationFilters} from './InvitationFilters';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {InvitationFormSchema, InvitationPageProps} from './invitationFormProps';
import {useInvitationState} from './hooks/useInvitationForm';
import {useLocalStorage} from '../../hooks/useLocalStorage';

const CompletedInner: React.FC = () => {
  const {values} = useInvitationState('completed');

  // DataGrid columns - using imported column definitions
  const columns = [
    accountNameColumn,
    clientsColumn,
    ownerColumn,
    meetingHostColumn,
    propositionTypeColumn,
    completedOnColumn,
    locationColumn,
    rtqStatusColumn(false),
    ecqStatusColumn(false),
  ];

  return (
    <>
      <InvitationFilters />
      <InvitationDataGrid
        inviteStatus={InvitationReviewsInput.COMPLETED}
        staff={values?.staff}
        search={values?.search}
        columns={columns}
        entityName="completed meetings"
        noDataMessage="No completed meetings found"
      />
    </>
  );
};

const CompletedWrapped = withAutoFormNew<InvitationFormSchema, InvitationPageProps>(
  CompletedInner,
  undefined,
  {debugPosition: 'bottom'}
);

export const CompletedPage: React.FC = () => {
  const [initialValue] = useLocalStorage<InvitationFormSchema>('completed', {
    staff: '',
    search: '',
  });
  return (
    <>
      <MeetingTabs />

      <CompletedWrapped initialValueOverrides={initialValue} formFields={[]} />
    </>
  );
};
